import React from "react";
import { Grid, Chip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    done: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      minWidth: "150px"
    },
    doing: {
      background: theme.palette.pending.main,
      color: theme.palette.primary.contrastText,
      minWidth: "150px"
    },
    pending: {
      background: "#b7b6b682",
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    },
    critical: {
      background: "#FC5F15",
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    },
    outOfDate: {
      background: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    }
  };
});

var EventAgendaProjects = function EventAgendaProjects(props) {
  // console.log("props agenda", props);
  var event = props.event.event;
  var classes = useStyles();

  var getTypeState = function getTypeState(status, date) {
    // console.group("Event props");
    // console.log("status", status);
    // console.log("date", date);
    console.groupEnd();
    var contentButton;
    var momentDateFinalCheck = moment().add(7, "days");
    var momentDateCurrentCheck = moment();

    if (status === "pending" || status === "doing") {
      if (moment(date).isBetween(momentDateCurrentCheck, momentDateFinalCheck)) {
        status += "_critical";
      }

      if (momentDateCurrentCheck.isAfter(moment(date)) && status === "pending") {
        status = "out_of_date";
      } else if (momentDateCurrentCheck.isAfter(moment(date)) && status === "doing") {
        status += "_out_of_date";
      }
    }

    switch (status) {
      case "pending":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.pending,
          label: "No empezado"
        });
        break;

      case "doing":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.doing,
          label: "En proceso"
        });
        break;

      case "done":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.done,
          label: "Hecho"
        });
        break;

      case "pending_critical":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.critical,
          label: "No empezado"
        });
        break;

      case "doing_critical":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.critical,
          label: "En proceso"
        });
        break;

      case "doing_out_of_date":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.critical,
          label: "En proceso"
        });
        break;

      case "out_of_date":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.outOfDate,
          label: "Fuera de fecha"
        });
        break;

      default:
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.pending,
          label: "No empezado"
        });
        break;
    }

    return contentButton;
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    onClick: function onClick() {
      return props.onClickEventAgenda(props.event);
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, event.title)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React.createElement(Chip, {
    label: event.state ? event.state.toUpperCase() : "ERROR"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, getTypeState(event.status, event.start)));
};

export { EventAgendaProjects };